import { cn } from '@/lib/utils';
import React from 'react';
import { Avatar } from './avatar';

type AvatarData = {
  name?: string;
  image?: string;
  _id?: string;
};

type AvatarsProps = {
  avatars: AvatarData[];
  size?: number;
  max?: number;
  className?: string;
  showCount?: boolean;
  count?: number;
} & React.HTMLAttributes<HTMLDivElement>;

const Avatars: React.FC<AvatarsProps> = ({ avatars = [], size = 10, max = 3, className, showCount = true, count = 0, ...props }) => {
  // If avatars.length < max, show all avatars, and no "+N"
  const visibleAvatars = avatars.slice(0, Math.max(0, max));
  const remainingCount = (count || avatars.length) > max ? (count || avatars.length) - max : 0;

  return (
    <div className={cn('flex items-center -space-x-5', className)} {...props}>
      {visibleAvatars.map((avatar, index) => (
        <Avatar key={avatar._id || index} name={avatar.name || ''} image={avatar.image || ''} size={size} className="ring-2 ring-white" />
      ))}

      {remainingCount > 0 && showCount && (
        <div
          className={cn(
            'flex items-center justify-center rounded-full bg-gray-200 ring-2 ring-white text-sm font-medium text-gray-600 tracking-tighter',
            size === 8 ? 'h-8 w-8' : size === 10 ? 'h-10 w-10' : size === 12 ? 'h-12 w-12' : 'h-10 w-10'
          )}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

export { Avatars };
export default Avatars;
